const LOCATION_ABBREVIATIONS: Record<string, string> = {
  "Bristol Node": "BRI",
  "Central Depot": "CEN",
  "Redditch Depot": "RED",
  "Silvertown Depot": "SIL",
  "Hayes Depot": "HAY",
  "South Node": "STH",
  "Brighton Node": "BTN",
}

const LOCATION_COLORS: Record<string, { bg: string; text: string }> = {
  SIL: { bg: "bg-palette-blueGreen000", text: "text-palette-blueGreen700" },
  HAY: { bg: "bg-palette-darkMagenta000", text: "text-indicators-purple" },
}

const DEFAULT_LOCATION_COLOR = {
  bg: "bg-palette-jungleGreen100",
  text: "text-palette-jungleGreen700",
}

export const getLocationAbbreviation = (location: string): string => {
  return LOCATION_ABBREVIATIONS[location] || location.slice(0, 3).toUpperCase()
}

export const getLocationColor = (abbreviation: string) => {
  return LOCATION_COLORS[abbreviation] || DEFAULT_LOCATION_COLOR
}
